import { SearchSuggestProduct } from '@/models/SearchSuggest';
import { safeLocalStorage } from './safeStorage';

const HISTORY_KEY = 'hzc_search_history';
const RECENT_KEY = 'hzc_search_recent';
const HISTORY_LIMIT = 8;
const RECENT_LIMIT = 8;

function readJson<T>(key: string, fallback: T): T {
  try {
    const raw = safeLocalStorage.getItem(key);
    if (!raw) return fallback;
    const parsed = JSON.parse(raw);
    return parsed as T;
  } catch {
    return fallback;
  }
}

export function getSearchHistory(): string[] {
  const rows = readJson<unknown>(HISTORY_KEY, []);
  if (!Array.isArray(rows)) return [];
  return rows
    .map((row) => String(row || '').trim())
    .filter(Boolean)
    .slice(0, HISTORY_LIMIT);
}

export function pushSearchHistory(term: string) {
  const value = String(term || '').trim();
  if (value.length < 2) return;
  const next = [
    value,
    ...getSearchHistory().filter(
      (row) => row.toLocaleLowerCase('tr') !== value.toLocaleLowerCase('tr'),
    ),
  ];
  safeLocalStorage.setItem(HISTORY_KEY, JSON.stringify(next.slice(0, HISTORY_LIMIT)));
}

export function clearSearchHistory() {
  safeLocalStorage.removeItem(HISTORY_KEY);
}

export function getRecentProducts(): SearchSuggestProduct[] {
  const rows = readJson<unknown>(RECENT_KEY, []);
  if (!Array.isArray(rows)) return [];
  return rows.filter(
    (row) => row && typeof row === 'object' && Number((row as SearchSuggestProduct).id) > 0,
  ) as SearchSuggestProduct[];
}

export function pushRecentProduct(product: SearchSuggestProduct) {
  if (!product?.id || !product.title) return;
  const compact: SearchSuggestProduct = {
    id: product.id,
    title: product.title,
    slug: product.slug || '',
    url: product.url || '',
    imageUrl: product.imageUrl || '',
    price: Number(product.price) || 0,
    priceBeforeDiscount: Number(product.priceBeforeDiscount) || 0,
  };
  const next = [compact, ...getRecentProducts().filter((row) => row.id !== compact.id)];
  safeLocalStorage.setItem(RECENT_KEY, JSON.stringify(next.slice(0, RECENT_LIMIT)));
}
